import type { TableDensity } from "@/ds";
import {
  FINANCEIRO_ACTION_COLUMN_WIDTH,
  FINANCEIRO_COLUMN_WIDTHS,
  FINANCEIRO_GROW_COLUMNS,
  FINANCEIRO_MOBILE_OBRA_WIDTH,
  FINANCEIRO_OBRAS_COLUMNS,
  FINANCEIRO_TAGS_COLUMNS,
} from "../../financeiro-obras.constants";
import type { FinanceiroObrasColumnKey } from "../../types-financeiro-obras";
import type { FinanceiroObrasListaColunas } from "./types-financeiro-obras-lista-view";

// Com `tableLayout: fixed` toda coluna precisa de largura: sem ela a coluna fica com 0 e some.
// Coluna nova da Lista = largura nova em `FINANCEIRO_COLUMN_WIDTHS`.
function larguraDaColuna(key: FinanceiroObrasColumnKey, density: TableDensity, isMobile: boolean) {
  if (key === "detalhamento") return FINANCEIRO_ACTION_COLUMN_WIDTH[density];
  if (isMobile && key === "id") return FINANCEIRO_MOBILE_OBRA_WIDTH;
  return FINANCEIRO_COLUMN_WIDTHS[key] ?? "0rem";
}

/**
 * Catálogo da Lista do Financeiro (colunas do Figma 12760:969941, ordem e rótulos) e as larguras: a tabela compartilhada
 * resolve mobile, densidade, fixação (ID, Embarcação e lupa) e cabeçalho a partir dele.
 */
export function useFinanceiroObrasListaViewColunas(): FinanceiroObrasListaColunas {
  return {
    catalogo: FINANCEIRO_OBRAS_COLUMNS,
    larguraDaColuna,
    colunasQueCrescem: FINANCEIRO_GROW_COLUMNS,
    colunasDeTags: FINANCEIRO_TAGS_COLUMNS,
  };
}
